module.exports = __webpack_public_path__ + "img/pdf_excel.1b7ac019.png";